import { Injectable } from '@angular/core';
import { TourService} from './tour.service';
import { TourApiService} from './tour-api.service';
import { Scene} from '../model/scene';
import { Option} from '../model/option';
import { OptionGroup} from '../model/option-group';
import { ModalService} from './modal.service';
import { Ad} from '../model/ad';
import { Image} from '../model/image';
import { Video} from '../model/video';
import {TrackingService} from './tracking.service';

@Injectable()
export class WishlistService {

  wishlistLoaded = false;
  wishlistScenes: Scene[] = [];
  constructor(public apiService: TourApiService, private tourService: TourService, private trackingService: TrackingService) {}

  clearWishlist() {
    localStorage.clear();
    this.wishlistScenes = [];
    this.saveWishlist();
  }

  logWishlist() {
    console.log(this.wishlistScenes);
  }

  logJSONWishlist() {
    const string = JSON.stringify(this.wishlistScenes);
    console.log(string);
    console.log(string.length);
  }

  loadWishlist() {
    if (!this.wishlistLoaded) {
      const localString = localStorage.getItem(this.apiService.builderModelPath());
      if (localString) {
        const jsonParse = JSON.parse(localString);
        for (const scene of jsonParse) {
          this.wishlistScenes.push(Scene.fromJSON(scene));
        }
      }
      for (const scene of this.tourService.tour.sceneList) {
        for (const optionGroup of scene.optionGroups) {
          for (const option of optionGroup.options) {
            if (this.isWishlistOption(option.id, scene.id)) {
              option.wishlisted = true;
            }
          }
        }
      }
      this.wishlistLoaded = true;
    }
  }

  saveWishlist() {
    localStorage.setItem(this.apiService.builderModelPath(), JSON.stringify(this.wishlistScenes));
  }

  // wishlistContains(option: Option) {
  //   console.log('wishlistContains');
  //   for (const wlScene of this.wishlistScenes) {
  //     const wlGroup = wlScene.findOptionGroupById(option.groupId);
  //     if (wlGroup && wlGroup.findOptionById(option.id)) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  isWishlistOption(optionId: number, sceneId: number) {
    for (const scene of this.wishlistScenes) {
      if (scene.id === sceneId) {
        for (const optionGroup of scene.optionGroups) {
          for (const option of optionGroup.options) {
            if (option.id === optionId) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  addOption(option: Option) {
    option.wishlisted = true;
    const optionCopy: Option = Object.assign(Object.create(Option.prototype), option);
    const wlScene = this.wishlistScene(optionCopy);
    const wlOptionGroup = this.wishlistOptionGroup(optionCopy, wlScene);
    if (!wlOptionGroup.findOptionById(optionCopy.id)) {
      wlOptionGroup.options.push(optionCopy);
    }
    this.saveWishlist();
    this.trackingService.trackAction(TrackingService.kActionWishlistOption, option.internalName, 0);
  }

  removeOption(option: Option) {
    const sceneOption = this.tourService.tour.findOption(option.sceneId, option.groupId, option.id);
    sceneOption.wishlisted = false;
    const wlScene = this.wishlistScene(option);
    if (wlScene) {
      const wlOptionGroup = this.wishlistOptionGroup(option, wlScene);
      const wlOption = wlOptionGroup.findOptionById(option.id);
      if (wlOption) {
        wlOptionGroup.options.splice(wlOptionGroup.options.indexOf(wlOption), 1);
        option.wishlisted = false;
        if (wlOptionGroup.options.length === 0) {
          wlScene.optionGroups.splice(wlScene.optionGroups.indexOf(wlOptionGroup), 1);
          if (wlScene.optionGroups.length === 0) {
            this.wishlistScenes.splice(this.wishlistScenes.indexOf(wlScene), 1);
          }
        }
      }
    }
    this.saveWishlist();
    // console.log(this.wishlistScenes);
  }

  wishlistScene(option: Option) {
    let wishlistScene: Scene;
    for (const scene of this.wishlistScenes) {
      if (scene.id === option.sceneId) {
        wishlistScene = scene;
        break;
      }
    }
    if (!wishlistScene) {
      const tourScene = this.tourService.tour.findSceneById(option.sceneId);
      const sceneCopy: Scene = Object.assign(Object.create(tourScene), tourScene);
      sceneCopy.optionGroups = [];
      wishlistScene = sceneCopy;
      this.wishlistScenes.push(wishlistScene);
    }
    return wishlistScene;
  }

  wishlistOptionGroup(option: Option, wlScene: Scene) {
    let wishlistOptionGroup: OptionGroup;
    // const wishlistScene: Scene;
      for (const group of wlScene.optionGroups) {
        if (group.id === option.groupId) {
          wishlistOptionGroup = group;
          break;
        }
      }

    if (!wishlistOptionGroup) {
      const tourGroup = this.tourService.tour.findOptionGroupById(option.groupId, wlScene.id);
      const groupCopy: OptionGroup = Object.assign(Object.create(tourGroup), tourGroup);
      groupCopy.options = [];
      wishlistOptionGroup = groupCopy;
      wlScene.optionGroups.push(wishlistOptionGroup);
    }
    return wishlistOptionGroup;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/wishlist.service.ts